export var TypeActionCheats;
(function (TypeActionCheats) {
    TypeActionCheats["Activate"] = "Cheats > Activate";
    TypeActionCheats["ActivateOfferGroup"] = "Cheats > ActivateOfferGroup";
    TypeActionCheats["ToggleFPSDisplay"] = "Cheats > ToggleFPSDisplay";
    TypeActionCheats["ClientIp"] = "Cheats > ClientIp";
})(TypeActionCheats || (TypeActionCheats = {}));
export var actionCheatsActivate = function (command, params) { return ({
    command: command,
    params: params,
    type: TypeActionCheats.Activate,
}); };
export var actionCheatsToggleFPSDisplay = function () { return ({
    type: TypeActionCheats.ToggleFPSDisplay,
}); };
export var actionCheatsActivateOfferGroup = function (offerGroup) { return ({
    offerGroup: offerGroup,
    type: TypeActionCheats.ActivateOfferGroup,
}); };
export var actionClientIpCheat = function (playerId) { return ({
    playerId: playerId,
    type: TypeActionCheats.ClientIp,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/cheats/actionCheats.ts
// module id = 614
// module chunks = 3